import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a76708dc&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=a76708dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76708dc",
  null
  
)

export default component.exports